import styled from "styled-components";

export const TimerContainer = styled.div`
  .timer-number-minutes {
    display: inline-block;
    width: 38px;
    text-align: center;
  }
  .timer-number-remainingSeconds {
    display: inline-block;
    min-width: 20px;
  }
  .timer-number-seconds {
    display: inline-block;
    width: 24px;
    text-align: center;
  }
`;
